module.exports = __webpack_public_path__ + "media/images/brand/meta_icons/apple-touch-icon-120x120-e8db8e534fd7ccca2447a6669fb16a2d.png";